var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlbumWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3333 4.16602C18.7936 4.16602 19.1667 4.53911 19.1667 4.99935V16.666C19.1667 17.5865 18.4205 18.3327 17.5 18.3327H4.16668C3.70644 18.3327 3.33334 17.9596 3.33334 17.4994C3.33334 17.0391 3.70644 16.666 4.16668 16.666H17.5V4.99935C17.5 4.53911 17.8731 4.16602 18.3333 4.16602Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 0.833984C0.447715 0.833984 0 1.2817 0 1.83398V14.834C0 15.3863 0.447714 15.834 0.999999 15.834H15.6667C16.219 15.834 16.6667 15.3863 16.6667 14.834V1.83398C16.6667 1.2817 16.219 0.833984 15.6667 0.833984H1ZM9.63606 4.55497C9.89171 4.30676 10.2384 4.16732 10.6 4.16732C10.9615 4.16732 11.3082 4.30676 11.5639 4.55497C11.8195 4.80318 11.9631 5.13983 11.9631 5.49085C11.9631 5.84187 11.8195 6.17851 11.5639 6.42672C11.3082 6.67493 10.9615 6.81438 10.6 6.81438C10.2384 6.81438 9.89171 6.67493 9.63606 6.42672C9.38042 6.17851 9.2368 5.84187 9.2368 5.49085C9.2368 5.13983 9.38042 4.80318 9.63606 4.55497ZM6.43682 7.1892C6.51247 7.09391 6.6244 7.04796 6.7359 7.04961C6.84739 7.05127 6.95872 7.10032 7.03143 7.19782L8.3014 8.89962L7.32341 10.0043C7.05259 10.31 7.27551 10.7836 7.69082 10.785C7.83259 10.7854 7.96732 10.7262 8.06001 10.6221L10.1971 8.22321C10.3456 8.05645 10.612 8.05771 10.7597 8.2258L13.2411 11.0521C13.4533 11.2943 13.2758 11.6673 12.9482 11.6673H3.77705C3.40945 11.6673 3.20158 11.2569 3.4265 10.9745L6.43682 7.1892Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlbumWhite);
export default __webpack_public_path__ + "static/media/album-white.9a6a6d8da67a9250eb0b29f930255be5.svg";
export { ForwardRef as ReactComponent };